import { useEffect, useRef, useState } from "react";
import { formatTime } from "../utils";

const CountdownTimer = ({ remainingSeconds }) => {
  return (
    <div style={{ position: "relative", top: "calc(50% - 180px)" }}>
      <div className="Countdown" style={{}}>
        {formatTime(remainingSeconds)}
      </div>
    </div>
  );
};

export { CountdownTimer };
